<template>
  <div class="focus-tip">
    <img src="@/assets/images/follow.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'FocusTip',
  data() {
    return {

    }
  },
  async mounted() {

  }
}
</script>

<style lang="scss" scoped>
  .focus-tip{
    padding: 15px;
    img{
      width: 100%;
    }
  }
</style>
